<template>
  <TheUncle :color="true" title="거래 로그" description="거래 로그입니다.">
    <div style="margin-bottom: 20px;">
      <a-alert
        style="margin-bottom: 0.5em;"
        type="warning"
        message="최근 7일 동안의 내역입니다."
        description="이전의 기록을 확인하려면 날짜를 선택해주세요."
        closable
        showIcon
      />

      <a-row :gutter="8">
        <a-col :span="24">
          <a-range-picker
            @change="onDateUpdate"
            :ranges="{ '오늘': [$moment(), $moment()], '이번 달': [$moment().startOf('month'), $moment().endOf('month')] }"
            format="LL"
          />
        </a-col>
      </a-row>
    </div>
    <a-card>
      <table class="list-type-2" v-if="items.length > 0">
        <thead>
          <tr>
            <td v-if="!isPC">거래 내역</td>
            <td v-if="isPC">날짜</td>
            <td v-if="isPC">타입</td>
            <td v-if="isPC">사유</td>
            <td v-if="isPC">발신인</td>
            <td v-if="isPC">수취인</td>
            <td v-if="isPC">금액</td>
          </tr>
        </thead>
        <tbody>
          <HistoryItem
            v-for="item in items"
            :key="item.idx"
            :to="item.to"
            :from="item.from"
            :reason="item.reason"
            :amount="item.amount"
            :timestamp="$moment(item.timestamp)"
          />
        </tbody>
      </table>

      <div class="card-empty" v-else>
        <i class="no-content-logo"></i>
        <p>기록이 없습니다.</p>
      </div>
    </a-card>
  </TheUncle>
</template>
<script>
import TheUncle from "@/components/Uncle/TheUncle";
import Axios from "axios";
import config from "../../config";
import AxiosMiddleware from "../../libs/AxiosMiddleware";
import OPCODE from "../../libs/OPCODE";
import HistoryItem from "../../components/History/HistoryItem";

export default {
  name: "UncleUnprocessed",
  components: { TheUncle, HistoryItem },
  data() {
    this.refreshHistory();
    return {
      items: [],
      selected: {}
    };
  },
  methods: {
    async refreshHistory() {
      const { data } = await Axios.post(
        `${config.hostname}/v1/uncle/history`,
        this.selected,
        { withCredentials: true }
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            this.items = data.histories;
            break;
        }
      }
    },
    onDateUpdate(dates) {
      this.selected.startTime = dates[0];
      this.selected.endTime = dates[1];
      this.refreshHistory();
    }
  }
};
</script>
<style scoped>
.ant-card-body {
  padding: 0px;
}

.ant-collapse-content > .ant-collapse-content-box {
  padding: 2px;
}
</style>